import React, { Component } from 'react';
import { withRouter } from '@/_helper/withRouter';
import { errorReport } from './errorReport';
import Header from '@/comp/header/Header';
import Footer from '@/comp/footer/Footer';
import StatusPage from '@/comp/statusPage/statusPage';
import * as storage from './storage';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidMount() {
        this.asyncErrors();
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        let date = new Date(),
            year = date.toLocaleString('default', { year: 'numeric' }),
            month = date.toLocaleString('default', { month: '2-digit' }),
            day = date.toLocaleString('default', { day: '2-digit' }),
            hours = ('0' + date.getHours()).slice(-2),
            minutes = ('0' + date.getMinutes()).slice(-2),
            seconds = ('0' + date.getSeconds()).slice(-2);

        let formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

        let page = this.props.location.pathname !== undefined ? this.props.location.pathname : '';
        let bookingNumber = storage.get('bookingNumber') !== undefined ? storage.get('bookingNumber') : '';
        let userAgent = navigator.userAgent;

        // set mode as web if not specified
        const mode = storage.get('mode') ?? 'web';

        // include error reporting service
        errorReport({
            timestamp: formattedDate,
            page: page,
            bookingNumber: bookingNumber,
            info: error?.stack,
            userAgent: userAgent,
            mode: mode,
        });
    }

    asyncErrors() {
        let $this = this;

        if (process.env.VITE_ENV === 'production') {
            console.error = (a) => {
                console.warn(`message: ${a}`);

                $this.setState({
                    hasError: true,
                });

                return true;
            };
        }

        window.onerror = (a, b, c, d, e) => {
            let errorLog = [];
            errorLog.push(`page : ${$this.props.location.pathname !== undefined ? $this.props.location.pathname : ''}`);
            if (storage.get('bookingNumber') !== null) {
                errorLog.push(`bookingNumber : ${storage.get('bookingNumber')}`);
            }
            errorLog.push(`message: ${a}`);
            errorLog.push(`source: ${b}`);
            errorLog.push(`lineno: ${c}`);
            errorLog.push(`colno: ${d}`);
            errorLog.push(`error: ${e}`);
            errorLog.push(`userAgent: ${navigator.userAgent}`);
            errorLog.push(`mode: ${storage.get('mode') ?? 'web'}`);

            $this.setState({
                hasError: true,
            });

            // include error reporting service
            errorReport(errorLog);

            return true;
        };
    }

    render() {
        return (
            <>
                {this.state.hasError ? (
                    <div className="page-error" history={this.history}>
                        <Header login={window.location.hash.indexOf('login') <= 0} />

                        <StatusPage
                            type="error"
                            subPage="error"
                            showButton={window.location.hash.indexOf('login') <= 0}
                        />

                        <Footer />
                    </div>
                ) : (
                    this.props.children
                )}
            </>
        );
    }
}

export default withRouter(ErrorBoundary);
